export enum KnmSearchActionsEnum {
  KNM_SEARCH_INIT_PAGE = 'KNM_SEARCH_INIT_PAGE',
  KNM_SEARCH_RESET_PAGE = 'KNM_SEARCH_RESET_PAGE',
  KNM_SEARCH_GET_DATA = 'KNM_SEARCH_GET_DATA',
  KNM_SEARCH_SET_DATA = 'KNM_SEARCH_SET_DATA',
  KNM_SEARCH_GET_DATA_NEXT_PAGE = 'KNM_SEARCH_GET_DATA_NEXT_PAGE',
  KNM_SEARCH_SET_ORDER = 'KNM_SEARCH_SET_ORDER',
  KNM_SEARCH_SET_FILTER = 'KNM_SEARCH_SET_FILTER',
  KNM_SEARCH_SET_SEARCH_STRING = 'KNM_SEARCH_SET_SEARCH_STRING',
  KNM_SEARCH_LOAD_FILE = 'KNM_SEARCH_LOAD_FILE',
  KNM_SEARCH_INIT = 'KNM_SEARCH_INIT',
  KNM_SEARCH_GET_KNM_SUPERVISION_TYPES_OPTIONS_ALL = 'KNM_SEARCH_GET_KNM_SUPERVISION_TYPES_OPTIONS_ALL',
  KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_OPTIONS_ALL = 'KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_OPTIONS_ALL',
  KNM_SEARCH_GET_KNM_SUPERVISION_TYPES_ERVK_OPTIONS_ALL = 'KNM_SEARCH_GET_KNM_SUPERVISION_TYPES_ERVK_OPTIONS_ALL',
  KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_ERVK_OPTIONS_ALL = 'KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_ERVK_OPTIONS_ALL',
}
